export const UNIQUE_CONFIG_KEY = 'special-promos-landing';
